<template>
  <div id="termos-combobox" ref="termos-combobox">
    <el-checkbox
      v-if="!termoAberto"
      v-model="myChecked"
      class="checkbox-input"
      @change="$emit('input', myChecked)"
    >
      <span
        style="cursor:pointer; font: normal normal normal 14px/19px Open Sans; letter-spacing: 0; color: #333333;"
      >
        Declaro que li e aceito os
      </span>
      <el-button
        class="btn-link"
        type="text"
        @click="abrirTermos"
      >
        termos de uso do serviço.
      </el-button>
    </el-checkbox>

    <dialog-default
      :open.sync="termoAberto"
      fullscreen
    >
      <template v-slot:title>
        <div></div>
      </template>
      <TermosDeUsoComponent
        :id-termo="idTermo"
        :verificar-data-aceite="verificarDataAceite"
        style="max-width: 1100px; margin: 0 auto;"
        @voltar="fecharTermo"
      />
    </dialog-default>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import TermosDeUsoComponent from '@/components/TermosDeUso/TermosDeUsoComponent'
import DialogDefault from '@/components/DialogDefault/DialogDefault.vue'

export default {
  name: 'TermoDeUsoCombobox',
  components: { DialogDefault, TermosDeUsoComponent },
  data () {
    return {
      termoDeUso: '',
      myChecked: false,
      termoAberto: false
    }
  },
  props: {
    idTermo: {
      type: [Number, String],
      default: 1
    },
    value: {
      type: Boolean,
      required: true
    },
    verificarDataAceite: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (newValue) {
      this.myChecked = newValue
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiTermoDeUso'])
  },
  methods: {
    async init () {
      this.myChecked = this.value
      await this.getUltimoTermoDeUsoValido()
    },
    async getUltimoTermoDeUsoValido () {
      const result = await this.apiTermoDeUso.getUltimoTermoDeUsoValido({
        payload: {
          'id_termo_uso_plat': this.idTermo
        },
        handlerErrorIgnore: true
      })
      this.termoDeUso = result.data
    },
    async aceitarTermo () {
      let aceite = false
      if (this.value === true) {
        aceite = await this.apiTermoDeUso.termosUsoConfirmarAceite({
          payload: {
            'id_termo_uso_plat': this.idTermo,
            'aceito': true,
            'versao': this.termoDeUso.versao,
            'id_termo_uso': this.termoDeUso.id_termo_uso
          },
          handlerErrorIgnore: true
        })
      }
      return aceite
    },
    abrirTermos () {
      this.termoAberto = true
    },
    fecharTermo () {
      this.termoAberto = false
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.btn-link {
  color: #006FB9;
  text-transform: none;
  font-family: 'Open Sans', SansSerif, serif;
  font-size: 14px;
  padding: 0;
  text-decoration: underline;
}

.btn-link:hover {
  opacity: 0.7;
}

.checkbox-input {
  vertical-align: bottom;
  cursor: pointer;
}

#termos-combobox {
  padding: 10px 0;
}
</style>
